import React from 'react'
import { Box } from '@mui/material'
import { buildTourSpotlightSx, tourDimSx } from './platformTourStyles'

/** Dims the app; with a menu entry to show, everything but that entry. */
export const PlatformTourBackdrop: React.FC<{ spotlightRect: DOMRect | null }> = ({ spotlightRect }) => {
  if (!spotlightRect) return <Box sx={tourDimSx} aria-hidden />

  return <Box sx={buildTourSpotlightSx(spotlightRect)} aria-hidden />
}
